import { useLoginRequestMutation as e } from "../queries/login/useLoginRequestMutation.mjs";
import { useLoginWithOtpMutation as t } from "../queries/login/useLoginWithOtpMutation.mjs";
import { useLoginWithPasswordMutation as n } from "../queries/login/useLoginWithPasswordMutation.mjs";
import { useLocalStorage as r } from "@maat/hooks";
//#region src/hooks/useLogin.ts
var i = () => {
	let [, i] = r("auth:hasSession", !1), a = e(), o = n(), s = t();
	return {
		requestLogin: async (e) => (await a.mutateAsync(e)).method,
		loginWithPassword: async (e) => {
			await o.mutateAsync(e), i(!0);
		},
		loginWithOtp: async (e) => {
			await s.mutateAsync(e), i(!0);
		},
		isPending: a.isPending || o.isPending || s.isPending,
		error: a.error || o.error || s.error,
		reset: () => {
			a.reset(), o.reset(), s.reset();
		}
	};
};
//#endregion
export { i as useLogin };
